import { useState } from 'react';
import authService from '../services/auth';

export const useTokenPurchase = (onSuccess) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: ''
  });
  const [generatedToken, setGeneratedToken] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('handleSubmit called');
    if (isSubmitting) return;
    
    setError(null);
    setIsSubmitting(true);

    try {
      // Validate form data
      if (!formData.name.trim()) {
        throw new Error('El nombre es obligatorio');
      }
      
      if (!formData.email.trim()) {
        throw new Error('El email es obligatorio');
      }
      
      // Basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email.trim())) {
        throw new Error('El formato del email no es válido');
      }
      
      console.log('Submitting form data:', {
        name: formData.name.trim(),
        email: formData.email.trim()
      });
      
      console.time('Token Generation');
      console.log('Starting token generation process', {
        name: formData.name.trim(),
        email: formData.email.trim()
      });

      const result = await authService.registerDirectStudent({
        name: formData.name.trim(),
        email: formData.email.trim()
      });
      
      console.timeEnd('Token Generation');
      console.log('API response received:', {
        success: result.success,
        hasToken: Boolean(result?.token),
        hasStudent: Boolean(result?.student)
      });

      if (!result?.success) {
        console.error('API returned error status:', result);
        throw new Error(result.message || 'Error en el registro. Por favor, inténtalo de nuevo.');
      }

      if (!result?.token) {
        console.error('Missing token in successful response:', result);
        throw new Error('Error al generar el token. Por favor, inténtalo de nuevo.');
      }

      console.log('Token generated successfully for student:', {
        studentId: result.student?.id,
        studentName: result.student?.name,
        tokenReceived: true
      });
      setGeneratedToken(result.token);
      onSuccess?.(result.token);
    } catch (err) {
      console.error('Token generation error:', err);
      setError(err.message || 'Error al procesar la solicitud. Por favor, inténtalo de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const updateField = (field, value) => {
    console.log(`updateField called: ${field} = ${value}`);
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const resetForm = () => {
    setFormData({ name: '', email: '' });
    setGeneratedToken(null);
    setError(null);
  };

  return {
    formData,
    isSubmitting,
    error,
    generatedToken,
    handleSubmit,
    updateField,
    resetForm
  };
};